<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g fill-rule="evenodd"><path d="M15.505 7a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h6Zm-10-6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z" fill="currentColor"/><g opacity=".75"><path d="M.005 6.5c0-3.59 2.422-6.5 6-6.5 3.065 0 4.844 1.816 5.664 4.348.11-.01.223-.015.337-.015a4.177 4.177 0 0 1 4 4.333A4.177 4.177 0 0 1 12.005 13h-6a6.265 6.265 0 0 1-6-6.5Z" opacity=".6" fill="currentColor"/><path d="M4.505 9.17a.2.2 0 0 1 .168.092l4.132 6.43a.2.2 0 0 1-.166.308H.37a.2.2 0 0 1-.166-.308l4.132-6.43a.2.2 0 0 1 .118-.085l.05-.006Z" fill="currentColor"/></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering120',
});
</script>
